/*
 * The top bar: menu (below lg), organisation, search (⌘K), language, notifications, user menu. Sticky, with
 * the landing's frosted glass over the canvas.
 */
import { List, MagnifyingGlass } from '@phosphor-icons/react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router'
import { IconButton } from '@/components/ui'
import { CommandTrigger } from './CommandPalette'
import { LanguageSwitch } from './LanguageSwitch'
import { LogoMark } from './Logo'
import { NotificationsPopover } from './NotificationsPopover'
import { OrgSwitcher } from './OrgSwitcher'
import { UserMenu } from './UserMenu'

export function TopBar({ onMenu, onSearch }: { onMenu: () => void; onSearch: () => void }) {
  const { t } = useTranslation('shell')
  return (
    <header className="sticky top-0 z-30 border-b print:hidden border-hairline/70 bg-app-canvas/80 backdrop-blur-xl backdrop-saturate-150">
      <div className="page-container flex h-16 items-center gap-2 sm:gap-3">
        <IconButton
          label={t('a11y.openMenu')}
          icon={<List />}
          onClick={onMenu}
          className="-ms-2 lg:hidden"
          tooltip={false}
        />
        <Link to="/overview" aria-label={t('a11y.home')} className="shrink-0 rounded-lg lg:hidden">
          <LogoMark className="h-7 w-auto" />
        </Link>
        <span aria-hidden="true" className="hidden h-6 w-px bg-hairline sm:block lg:hidden" />
        <OrgSwitcher className="hidden min-w-0 sm:flex" />
        <div className="flex flex-1 justify-center px-2">
          <CommandTrigger onOpen={onSearch} className="hidden md:flex" />
        </div>
        <div className="flex items-center gap-0.5 sm:gap-1">
          <IconButton
            label={t('command.title')}
            icon={<MagnifyingGlass />}
            onClick={onSearch}
            className="md:hidden"
            tooltip={false}
          />
          <LanguageSwitch className="hidden sm:inline-flex" />
          <NotificationsPopover />
          <span className="ms-1">
            <UserMenu />
          </span>
        </div>
      </div>
    </header>
  )
}
